import "./Callout.scss";
import { ErrorExagon, Info } from "@/icons";

export enum CalloutVariantEnum {
  INFO = "info",
  WARNING = "warning",
  DANGER = "danger",
  SUCCESS = "success",
}

interface CalloutProps {
  title: string;
  description: React.ReactNode;
  variant?: CalloutVariantEnum;
}

const iconMap = {
  info: <Info color="primary" />,
  warning: <Info color="warning" />,
  danger: <ErrorExagon />,
  success: <Info color="status-success" />,
};

export function Callout({
  title,
  description,
  variant = CalloutVariantEnum.INFO,
}: CalloutProps) {
  return (
    <div className={`callout callout-${variant} p-x40`}>
      <div className="callout-header">
        {iconMap[variant]}
        <span className="callout-title">{title}</span>
      </div>
      <div className="callout-body">{description}</div>
    </div>
  );
}
